
class SectionVs extends HTMLElement {
    constructor() {
        super();

        // Initialize the swiper section-vs__grid--mobile--nav  to be the thumb of the swiper
        this.swiperThumbs = new Swiper(this.querySelector('.section-vs__grid--mobile--nav'), {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 2,
            spaceBetween: 12,
        });


        this.swiper = new Swiper(this.querySelector('.swiper-vs'), {
            direction: 'horizontal',
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1000,
            navigation: {
                nextEl: this.querySelector('.button-next'),
                prevEl: this.querySelector('.button-prev'),
            },
            thumbs: {
                swiper: this.swiperThumbs,
            },
        });



        document.querySelectorAll('.section-vs__grid--mobile--nav-item').forEach((button) => {
            button.addEventListener('click', () => {
                document.querySelectorAll('.section-vs__grid--mobile--nav-item').forEach((btn) => {
                    btn.classList.remove('active');
                });
                button.classList.add('active');
            });
        });

    }

}

customElements.define('section-vs', SectionVs); 